import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import type { Submission } from "@/types";
import { Card } from "@/components/ui/Card";
import { ResultsCard } from "@/components/quiz/ResultsCard";
import { Spinner } from "@/components/ui/Spinner";

export default function TestComplete() {
  // L'URL: /test/:slug/grazie?submissionId=...
  // (lo passiamo come query così il messaggio resta semplice)
  const { slug } = useParams<{ slug: string }>();
  const submissionId = new URLSearchParams(window.location.search).get("s");

  const [submission, setSubmission] = useState<Submission | null>(null);
  const [loading, setLoading] = useState(!!submissionId);

  useEffect(() => {
    if (!submissionId) return;
    api.get<{ submission: Submission }>(`/submissions/${submissionId}/results`)
      .then((r) => setSubmission(r.submission))
      .catch(() => {/* submissionId non valido — pagina mostra solo il "grazie" */})
      .finally(() => setLoading(false));
  }, [submissionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="max-w-xl w-full space-y-6">
        <Card className="text-center space-y-3">
          <div className="text-6xl">🙏</div>
          <h1 className="text-3xl font-serif text-primary">
            Grazie per aver completato il test
          </h1>
          <p className="text-secondary">
            Le tue risposte sono state registrate. Il docente le esaminerà
            insieme alle tue interpretazioni.
          </p>
          {slug && (
            <div className="font-mono text-xs text-muted pt-2">{slug}</div>
          )}
        </Card>

        {loading && (
          <div className="flex justify-center"><Spinner size={28} /></div>
        )}

        {submission && submission.scoreMassimo != null && (
          <ResultsCard submission={submission} />
        )}
      </div>
    </div>
  );
}
